export const initialState = {
  isRegistered: false,
  isEmailVerified: "",
  isLoggedIn: false,
  isFound: null,
  loginType: null,
  authData: {},
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SIGNUP":
      let code = '';
      if (action.payload.data.data.data.code !== undefined) {
        code = action.payload.data.data.data.code
      }
      return {
        ...state,
        isRegistered: action.payload.data.isRegistered,
        code
      };
    case "EMAILVERIFICATION":
      return {
        ...state,
        isEmailVerified: action.payload.data.message,
        isRegistered: "",
      };
    case "LOGIN":
      return {
        ...state,
        isLoggedIn: true,
        authData: action.payload.data.user,
      };
    case "SOCIALLOGIN":
      return {
        ...state,
        isLoggedIn: action.payload.data.isFound ? true : false,
        isFound: action.payload.data.isFound,
        loginType: action.payload.data.type,
        authData: action.payload.data.user,
      };
    case "LOGOUT":
      return {
        ...state,
        isLoggedIn: false,
        isRegistered: "",
        isEmailVerified: "",
        isFound: null,
        loginType: null,
        authData: {},
      };
    case "UPDATEUSERSETTINGS":
      return {
        ...state,
        isUpdated: action.payload.data.message,
        authData: {
          ...state.authData,
          ...action.payload.data,
        },
      };
    case "ERROR":
      return {
        ...state,
        isRegistered: false,
        code: ''
      };
      case "UPDATE_LOGIN_TYPE":
      return {
        ...state,
        loginType: action.payload.data.type,
        code: ''
      };
    default:
      return state;
  }
};
